import React from "react";
import { Toaster } from "sonner";

export const wrapRootElement = ({ element }) => (
	<>
		{element}
		<Toaster
			toastOptions={{
				style: { background: "var(--color-toast)", border: "none" },
			}}
			position='bottom-center'
		/>
	</>
);
